import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ElementWrapper = styled.div`
  position: absolute;
  box-shadow: ${({ theme }) => `inset 0px 0px 0px 2px ${theme.Color.System.Primary}`};

  :hover {
    box-shadow: ${({ theme }) => `inset 0px 0px 0px 2px ${theme.Color.System.Dark}`};
  }
`;

export default function ElementContainer ({ children, width, height, x, y, rotation, ...props }) {
  return (
    <ElementWrapper
      {...props}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        left: `${x}px`,
        top: `${y}px`,
        transform: `rotate(${rotation}deg)`
      }}
    >
      {children}
    </ElementWrapper>
  );
}

ElementContainer.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  children: PropTypes.node
};
